<template>
  <div
    :class="`formulate-input-element formulate-input-element--${context.class}`"
    :data-type="context.type"
  >
    <input
      type="text"
      :class="[small && 'small', context.attributes.class]"
      v-model="context.model"
      v-bind="context.attributes"
      @blur="context.blurHandler"
      @paste.prevent
    />
  </div>
</template>

<script>
export default {
  name: "TTTextInputPrevent",
  props: {
    context: Object,
    small: Boolean
  }
};
</script>
